export const initialState = {
  user: null,
  mainLoader: false,
  allConcepts: null,
  allUsers: null,
  allTrainers: null,
  alertState: false,
  alertType: null,
  conceptDetailById: null,
  favourites: null,
};
